import "./OrderDetailsStyles.scss"

import React, {useEffect, useState, useCallback} from 'react';
import {useLocation} from "react-router-dom";
import {useGetDetailsInformation} from "../hooks/useGetDetailsInformation/useGetDetailsInformation";
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import OrderDetailsBase from "./OrderDetailsBase/OrderDetailsBase";
import OrderDetailsEdit from "./OrderDetailsEdit/OrderDetailsEdit";

const OrderDetails = () => {
    const location = useLocation();

    const guid = location.state?.data;
    const statuses_id = location.state?.statuses_id;

    const {
        detailInformation,
        loading,
        error,
        fetchDetailsInformation,
    } = useGetDetailsInformation();

    // Общий алерт только для ошибки загрузки
    const [loadAlert, setLoadAlert] = useState({
        isOpen: false, title: '', message: '', statusCod: '',
    });

    const closeLoadAlert = () => setLoadAlert(prev => ({...prev, isOpen: false}));

    useEffect(() => {
        if (guid) fetchDetailsInformation(guid);
    }, [guid, fetchDetailsInformation]);

    useEffect(() => {
        if (error) {
            setLoadAlert({
                isOpen: true,
                title: error.title || 'Ошибка',
                message: error.message,
                statusCod: error.statusCode,
            });
        }
    }, [error]);

    const isEditMode = Number(statuses_id) === 2;

    return (
        <div className={"order_details-page max--width--control"}>
            <ButtonBack/>

            <CustomAlert
                title={loadAlert.title}
                message={loadAlert.message}
                statusCod={loadAlert.statusCod}
                isOpenAlert={loadAlert.isOpen}
                onClose={closeLoadAlert}
            />

            {loading ? (
                <div>Загрузка...</div>
            ) : !detailInformation ? (
                <div className={"order_details-empty"}>Данные не найдены</div>
            ) : isEditMode ? (
                <OrderDetailsEdit
                    detailInformation={detailInformation}
                />
            ) : (
                <OrderDetailsBase
                    detailInformation={detailInformation}
                    statuses_id={statuses_id}
                />
            )}
        </div>
    );
};

export default OrderDetails;